import Ajax from '@utils/ajax';

export default {
  userInfo(user_id) {
    return Ajax.get({
      url: `/internal_admin/user_info`,
      data: { user_id: user_id },
    });
  },

  groupInfo(user_id, group_id) {
    return Ajax.get({
      url: `/internal_admin/group_info`,
      data: { user_id: user_id, group_id: group_id },
    });
  },

  activityInfo(user_id) {
    return Ajax.get({
      url: `/internal_admin/activity_info`,
      data: { user_id: user_id },
    });
  },

  recentActivityInfo(user_id) {
    return Ajax.get({
      url: `/internal_admin/recent_activity_info`,
      data: { user_id: user_id },
    });
  },

  personalizationInfo(user_id) {
    return Ajax.get({
      url: `/internal_admin/personalization_info`,
      data: { user_id: user_id },
    });
  },

  toggleDemoMode() {
    return Ajax.post({
      url: `/internal_admin/toggle_demo_mode`,
    });
  },

  createBonusTransaction(data) {
    return Ajax.post({
      url: `/internal_admin/create_bonus_transaction`,
      data: data,
    });
  },

  referredUsers(user_id) {
    return Ajax.get({
      url: `/internal_admin/referred_users`,
      data: { user_id: user_id },
    });
  },
};
